import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { PermissionService } from '@/app/core/services/permission.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
    constructor(
        private permissionService: PermissionService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const pathOnly = state.url.split('?')[0];
        const currentRoute = pathOnly.startsWith('/') ? pathOnly : `/${pathOnly}`;
        if (currentRoute === '/system/dashboard') {
            return true;
        }
        if (currentRoute === '/notifications') {
            return true;
        }
        const permission = this.permissionService.getPermissionByRoute(currentRoute || '/user/users');
        if (!permission) {
            this.router.navigateByUrl('/system/dashboard');
            return false;
        }
        return true;
    }
}
